import { EventType, Events } from '../utils/Events.js'
import { Sleep } from '../utils/Sleep.js'
import { isSafari, isMobile } from '../utils/Support'
import { Config } from './Config.js'

export class Layout {
  static async init() {
    this.w = innerWidth
    this.h = innerHeight
    this.aspect = 1
    this.mouse = {
      x: innerWidth / 2,
      y: innerHeight / 2,
      distance: 0,
    }

    this.isMobile = isMobile()
    this.inMobileMode = this.w <= Config.BREAKPOINTS.MD

      
    this.dpr = isSafari && !this.isMobile ? 1 : 1.5

    if (isSafari) {
      document.documentElement.classList.add('is-safari')
    }

    this.addListeners()

    await Sleep(200)

    this.onResize()
  }

  static setScroll(scroll) {
    this.scroll = scroll
  }

  static addListeners() {
    Events.on(EventType.FORCE_RESIZE, this.onResize)

    addEventListener('resize', this.onResize, { passive: true })
    addEventListener('mousemove', this.onMouseMove)
  }

  static destroy() {
    Events.off(EventType.FORCE_RESIZE, this.onResize)

    removeEventListener('resize', this.onResize)
    removeEventListener('mousemove', this.onMouseMove)
  }

  static onResize = () => {
    const { innerWidth: w, innerHeight: h } = window
    
    const mobileMode = w <= Config.BREAKPOINTS.MD

    this.w = w
    this.h = h
    this.aspect = w / h

    if(this.inMobileMode !== mobileMode) {
      this.inMobileMode = mobileMode
      Events.emit(EventType.MOBILE_MODE, this.inMobileMode)
    }

    Events.emit(EventType.RESIZE, { w: this.w, h: this.h, dpr: this.dpr })
  }

  static onMouseMove = ({ clientX, clientY }) => {
    this.mouse.x = clientX
    this.mouse.y = clientY

    // calculate mouse distance from center
    const x = this.mouse.x - this.w / 2
    const y = this.mouse.y - this.h / 2
    const distance = Math.sqrt(x * x + y * y)
    this.mouse.distance = distance

    Events.emit(EventType.MOUSE_UPDATE, this.mouse, { w: this.w, h: this.h })
  }
}
